const initialState = {
  sidebarOpen: false,
  sidebarItems: [],
  staticMenuItem: false,
  staticMenuItemId: undefined,
  staticMenuUrl: '',
  staticMenuComponent: undefined
};

const SidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_LOGOUT' || 'INVALID_USER':
      return initialState;
    case 'SIDEBAR_OPEN':
      return {
        ...state,
        sidebarOpen: action.payload
      };
    case 'SIDEBAR_ITEMS_LOADED': {
      return {
        ...state,
        sidebarItems: action.payload
      };
    }
    default:
      return state;
  }
};

export default SidebarReducer;
